import { useEffect, PropsWithChildren } from 'react';
import { useIsAuthenticated, useMsal, MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export function useCallAzureAuth() {
  const { instance } = useMsal();
  return () => instance.handleRedirectPromise().then(async (response) => {
    if (response === null) {
      const currentAccounts = instance.getAllAccounts();

      if (currentAccounts.length === 0) {
        await instance.loginRedirect(loginRequest);
      }
    }
  });
}

export function useIsAzureAuth() {
  const isAuthenticated = useIsAuthenticated();
  const callAzureAuth = useCallAzureAuth();
  useEffect(() => {
    (async () => {
      await callAzureAuth();
    })();
  }, [isAuthenticated]);

  return isAuthenticated;
}

export function useLogoutAzure() {
  const { instance } = useMsal();
  return () => instance.logoutRedirect();
}

export function AzureAuthed({ children }: PropsWithChildren<{}>) {
  const isAzureAuth = useIsAzureAuth();
  return (<>{isAzureAuth && children}</>);
}

export function AzureProvider({ children }: PropsWithChildren<any>) {
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
}

export function AzureGuard({ children }: PropsWithChildren<{}>) {
  return (
    <AzureProvider>
      <AzureAuthed>
        {children}
      </AzureAuthed>
    </AzureProvider>
  );
}
